export default function (adminURL, instance) {
  return {
    getSections: (payload) => instance.post(adminURL + "section/all", payload),
  };
}
